import type { CurrencyFormat, Money } from "../api/types";
import { currencyExponent } from "../api/types";
import { HOME_CURRENCY, moneyToNumber } from "./money";

/// nb-NO — the app is Norwegian throughout (NOK, `kr`, Norwegian bank
/// statements), and `formatSummaryCurrency` below already renders this way.
/// Note the thousands separator is a non-breaking space, so tests that assert
/// on the output need a `\s`-tolerant matcher.
const TRANSACTION_LOCALE = "nb-NO";

const transactionFormatter = (exponent: number) =>
  new Intl.NumberFormat(TRANSACTION_LOCALE, {
    style: "decimal",
    minimumFractionDigits: exponent,
    maximumFractionDigits: exponent,
  });

export const formatTransactionCurrency = (
  money: Money | null | undefined,
  format: CurrencyFormat,
): string => {
  if (money === null || money === undefined) return "";

  // Currently only supports Nok as per requirement
  if (format === "Nok") {
    // Format: 1 000,12 kr. A foreign amount carries its own currency, so it
    // displays e.g. "1 000,12 USD".
    const exponent = currencyExponent(money.currency);
    const formattedNumber = transactionFormatter(exponent).format(
      moneyToNumber(money),
    );

    const suffix =
      money.currency === HOME_CURRENCY ? " kr" : ` ${money.currency}`;
    return `${formattedNumber}${suffix}`;
  }

  // Fallback
  return money.amount;
};

export const formatSummaryCurrency = (money: Money | null): string => {
  if (money === null) return "";
  return moneyToNumber(money).toLocaleString("nb-NO", {
    style: "currency",
    currency: money.currency,
  });
};
